module.exports = __webpack_public_path__ + "static/media/pear.958d76e7.png";